import Button from '__components/Button';
import useModal from '__components/Modals/useModal';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CreateWebhookModal, WebhookData } from './CreateWebhookModal';
import { useSelector } from 'react-redux';
import { getAuthTeamMember } from 'store/authentication/selectors';
import { generateCSV } from 'pages/SmartConnectors/SmartConnector/helpers';

type CreateWebhookButtonProps = {
  fileInputRef: React.RefObject<HTMLInputElement>;
};

// format: webhook-sample-YYYY-MM-DD_hh-mm-ss.csv
const getCSVFileName = () =>
  `webhook-sample-${new Date()
    .toLocaleDateString('en')
    .split('/')
    .join(
      '-'
    )}_${new Date().toLocaleTimeString('en', { hour12: false }).split(':').join('-')}.csv`;

export const CreateWebhookButton: FC<CreateWebhookButtonProps> = ({
  fileInputRef,
}) => {
  const { t } = useTranslation();
  const authTeamMember = useSelector(getAuthTeamMember);

  const [modalProps, { onClick }] = useModal({
    handleSubmit: ({ queryString, body }: WebhookData) => {
      if (fileInputRef.current) {
        const csvText = generateCSV([
          ['timestamp', 'employee_id', 'querystring', 'body'],
          [
            `${Date.now()}`,
            authTeamMember.id,
            queryString,
            `"${body.replace(/"/g, '""')}"`,
          ],
        ]);

        const dataTransfer = new DataTransfer();
        const file = new File(
          [new Blob([csvText], { type: 'text/csv;charset=utf-8' })],
          getCSVFileName()
        );
        dataTransfer.items.add(file);

        fileInputRef.current.focus();
        fileInputRef.current.files = dataTransfer.files;
        fileInputRef.current.dispatchEvent(
          new Event('change', { bubbles: true })
        );
        fileInputRef.current.blur();
      }
    },
  });

  return (
    <>
      <Button variant="outline" color="blue" onClick={onClick}>
        {t('Generate Sample File')}
      </Button>
      {modalProps.show ? <CreateWebhookModal {...modalProps} /> : null}
    </>
  );
};
